import React from 'react';
import Grid from '@mui/material/Grid';
import './styles.scss';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AdmirationIconSVGR from '../../../../../../assets/svgr/AdmirationIconSVGR';

const DidYouKnow = () => (
  <Grid container className='did-you-know-container'>
    <Container>
      <Grid container textAlign='center' justifyContent='center' mt={12} mb={12}>
        <Grid item xs={12}>
          <AdmirationIconSVGR />
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Typography className='did-you-know title' variant='span'>
              Did you know?
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} className='description' mt={2}>
          <Box>
            <Typography className='did-you-know description' variant='span'>
              The
              {' '}
            </Typography>
            <Typography className='did-you-know description-bold' variant='span'>
              PlanGap®
              {' '}
            </Typography>
            <Typography className='did-you-know description' variant='span'>
              Benefit¹, available through the
              {' '}
            </Typography>
            <Typography className='did-you-know description-bold' variant='span'>
              North American Secure Horizon℠ Choice fixed index annuity and the optional Retirement Benefits Rider
            </Typography>
            <Typography className='did-you-know description' variant='span'>
              , is the first benefit within an FIA designed to offset potential Social Security reductions.²
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Grid>
);

export default DidYouKnow;
